import React, { useEffect, createElement } from 'react';
import { StickyTopBar } from './components/StickyTopBar';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { TransformationSection } from './components/TransformationSection';
import { BenefitsGrid } from './components/BenefitsGrid';
import { ProductBreakdown } from './components/ProductBreakdown';
import { ProductPreview } from './components/ProductPreview';
import { ValueStack } from './components/ValueStack';
import { OfferSection } from './components/OfferSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
declare global {
  interface Window {
    fbq: (...args: unknown[]) => void;
    _fbq: (...args: unknown[]) => void;
  }
}
export function App() {
  useEffect(() => {
    // Meta Pixel initialization
    if (typeof window.fbq === 'function') return;
    const n: any = window.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!window._fbq) window._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [] as unknown[];
    const t = document.createElement('script');
    t.async = true;
    t.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const s = document.getElementsByTagName('script')[0];
    s?.parentNode?.insertBefore(t, s);
    window.fbq('init', '3144851492364102');
    window.fbq('track', 'PageView');
    // noscript fallback
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=3144851492364102&ev=PageView&noscript=1';
    document.body.appendChild(img);
  }, []);
  return <div className="min-h-screen bg-white font-sans text-dark selection:bg-primary/30" data-id="element-0">
      <StickyTopBar data-id="element-1" />

      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <ProblemSection data-id="element-4" />
        <TransformationSection data-id="element-5" />
        <BenefitsGrid data-id="element-6" />
        <ProductBreakdown data-id="element-7" />
        <ProductPreview data-id="element-8" />
        <ValueStack data-id="element-9" />
        <OfferSection data-id="element-10" />
        <TestimonialsSection data-id="element-11" />
        <FAQSection data-id="element-12" />
        <FinalCTA data-id="element-13" />
      </main>

      <footer className="bg-darker text-gray-500 py-8 text-center text-sm border-t border-white/10" data-id="element-14">
        <div className="max-w-7xl mx-auto px-4" data-id="element-15">
          <p data-id="element-16">
            © {new Date().getFullYear()} 5K Sin Rendirse. Todos los derechos
            reservados.
          </p>
          <p className="mt-2 text-xs" data-id="element-17">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio NO está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca comercial de FACEBOOK, Inc.
          </p>
        </div>
      </footer>
    </div>;
}